export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/service-ticket.e68afd75-e41f0c.png";